
<div *ngIf="alertas.length == 0; else alertasEncontrados">
 <p>Nenhum alerta encontrado</p>
</div>

<ng-template #alertasEncontrados>
  <div  *ngFor="let alerta of alertas" >
    <app-alerta-card-notificacao 
    [telaPrincipal]="false"
    [roteiroAlerta]="alerta"
    ></app-alerta-card-notificacao>
   </div>
</ng-template>

